module.exports = __webpack_public_path__ + "img/file_management_active.3867042b.svg";